import React from 'react';

import FadeIn from 'src/components/FadeIn';

import { CopyImageColumnsProps } from './CopyMediaColumns.types';
import { CopyMediaColumns } from './CopyMediaColumns';
import styles from './CopyMediaColumns.module.scss';

export const CopyImageColumns: React.FC<CopyImageColumnsProps> = ({
  className = '',
  copyChildren,
  copyContainerClassName,
  title,
  subtitle,
  overline,
  paragraph,
  variant,
  isLargerTitle,
  isXLargeTitle,
  isLargerParagraph,
  imageUrl,
  imageAlt,
  imageChildren,
  reverseOrder = false,
  isCentered = false,
  svg,
}) => {
  const image = imageUrl && (
    <FadeIn duration={0.3}>
      <img
        className={styles.copyMediaColumns__image}
        alt={imageAlt}
        src={imageUrl}
        data-cy="copy-image-columns-image"
      />
    </FadeIn>
  );

  return (
    <CopyMediaColumns
      className={className}
      copyChildren={copyChildren}
      copyContainerClassName={copyContainerClassName}
      mediaChildren={imageChildren || image}
      overline={overline}
      title={title}
      subtitle={subtitle}
      paragraph={paragraph}
      variant={variant}
      isLargerTitle={isLargerTitle}
      isXLargeTitle={isXLargeTitle}
      isLargerParagraph={isLargerParagraph}
      reverseOrder={reverseOrder}
      isCentered={isCentered}
      svg={svg}
    />
  );
};
